import { __ } from '@wordpress/i18n';
import { PanelBody, ToggleControl } from '@wordpress/components';

export default function SourcePanel({ attributes, setAttributes }) {
  const isDynamic = attributes.isDynamic ?? false;

  return (
    <PanelBody title={__('Source', 'brandy-blocks')} initialOpen={true}>
      <ToggleControl
        __nextHasNoMarginBottom
        label={__('Dynamic content', 'brandy-blocks')}
        help={
          isDynamic
            ? __('Items are populated from queried posts.', 'brandy-blocks')
            : __('Items are manually added.', 'brandy-blocks')
        }
        checked={isDynamic}
        onChange={(value) => setAttributes({ isDynamic: value })}
      />
    </PanelBody>
  );
}
